// 첫로딩이 너무길어서 서버랑 통신하기전에 먼저 보여준다 ㅜ.ㅜ
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'

const useLinerStyles = makeStyles(theme => ({
    root: {
        width: 80,
        borderRadius: 5,
        marginTop: 50,
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(214, 214, 214, .2)',
        zIndex: -100000,
        
    },
    bar: {
        background: 'rgba(214, 214, 214, 1)'
    }
}))

function LineLoadingCmponent() {
    const classesLinear = useLinerStyles()
    
    return (
        <LinearProgress classes={classesLinear}/>
    )
}

export default LineLoadingCmponent